var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5735 16.0419C39.9325 15.8827 40.3254 15.8278 40.7113 15.8829C41.0973 15.938 41.4621 16.101 41.7679 16.3551C42.0738 16.6092 42.3094 16.9449 42.4502 17.3275C42.591 17.71 42.632 18.1253 42.5688 18.5302L39.2743 39.583C38.9547 41.6137 36.8398 42.7783 35.0719 41.7668C33.5932 40.9205 31.3969 39.6167 29.4214 38.2562C28.4336 37.5752 25.4079 35.3945 25.7797 33.8427C26.0993 32.5159 31.1834 27.5301 34.0885 24.5658C35.2288 23.4012 34.7088 22.7294 33.3622 23.8007C30.0184 26.4604 24.6496 30.5051 22.8745 31.6436C21.3086 32.6475 20.4923 32.8189 19.5161 32.6475C17.7353 32.3353 16.0837 31.8517 14.7357 31.2626C12.9141 30.4668 13.0027 27.8285 14.7342 27.0603L39.5735 16.0419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.1bfe1b0a423599c3ea24ae93c894608d.svg";
export { ForwardRef as ReactComponent };